<template>
  <div class="app-container">
    <div class="top-content">
      <div class="bg-content">
        <div class="bg-content">
          <img class="image" :src="headerInfo.backgroundImageUrl" />
        </div>
      </div>
      <div class="top-text">
        <div class="title">{{ headerInfo.title }}</div>
        <div class="search-box">
          <div class="input-box">
            <el-input
              v-model="params.keyword"
              placeholder="请输入关键字…"
            ></el-input>
          </div>
          <div class="line"></div>
          <div class="search-image" @click="onSearchClick">
            <img class="image" src="@/assets/icon_search.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="main-content">
      <div class="tab-box">
        <div class="title-tab">帮助中心分类</div>
        <div class="list-box">
          <div class="tab-list" v-for="(item, index) in tabArr" :key="index">
            <div
              :class="active === index ? 'tab-item-select' : 'tab-item'"
              @click="onTabClick(index, item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="!item" class="tab-content">
        <div class="content-title">
          <span v-if="tabArr.length > 0">{{
            active > -1 ? tabArr[active].name : "搜索结果"
          }}</span>
        </div>
        <div
          v-for="(item, index) in listData"
          :key="index"
          class="content-list-item"
          @click="onItemClick(item)"
        >
          <div class="name">
            {{ item.title }}
          </div>
          <div class="time">{{ item.publishTime }}</div>
        </div>
        <pagination
          :total="total"
          layout="total,prev,pager,next"
          :page.sync="listQuery.pageIndex"
          :limit.sync="listQuery.pageSize"
          @pagination="getpaginationList"
        />
      </div>
      <div v-else class="item-detail">
        <div class="app-main">
          <div class="title">{{ item.title }}</div>
          <div class="desc-box">
            <span class="author">作者：{{ item.author }}</span>
            <span class="time">发表时间：{{ item.publishTime }}</span>
          </div>
          <div class="html-box">
            <p class="rich-text" v-html="item.content"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import {
  getHelpHeader,
  getHelpTypeList,
  getHelpList,
  getHelpView,
} from "@/api/help";
export default {
  name: "Help",
  components: { Pagination },
  data() {
    return {
      active: 0,
      params: { keyword: "", helpTypeId: -1 },
      headerInfo: {},
      tabArr: [],
      listData: [],
      item: undefined,
      total: 0,
      listQuery: {
        pageIndex: 1,
        pageSize: 7,
      },
      helpTypeId: undefined,
      aarItemId: "",
    };
  },
  mounted() {
    const url = window.location.href;
    const cs = url.split("?")[1];
    if (cs) {
      const cs_arr = cs.split("&");
      var csr = {};
      for (var i = 0; i < cs_arr.length; i++) {
        csr[cs_arr[i].split("=")[0]] = cs_arr[i].split("=")[1];
      }
      this.helpTypeId = csr.helpTypeId;
      this.aarItemId = csr.id;
    }
    this._getHelpHeader();
    this._getHelpTypeList();
  },
  methods: {
    onTabClick(index, item) {
      this.helpTypeId = undefined;
      this.active = index;
      this.item = undefined;
      const { id } = item;
      this.params.helpTypeId = id;
      this.params.keyword = "";
      this.listQuery.pageIndex = 1;
      this._getHelpList();
    },
    //搜索
    onSearchClick() {
      getHelpList({ ...this.params, helpTypeId: -1, ...this.listQuery })
        .then((res) => {
          this.active = -1;
          this.item = undefined;
          const {
            data: { totalCount, data },
          } = res;
          this.total = totalCount;
          this.listData = [...data];
        })
        .catch((res) => {})
        .finally(() => {});
    },
    getpaginationList() {
      this._getHelpList();
    },
    onItemClick(item) {
      const { id } = item;
      this._getHelpView(id);
    },
    //封头配置
    _getHelpHeader() {
      getHelpHeader()
        .then((res) => {
          const { data } = res;
          this.headerInfo = { ...data };
        })
        .catch((res) => {})
        .finally(() => {});
    },
    //帮助类型列表
    _getHelpTypeList() {
      getHelpTypeList()
        .then((res) => {
          const { data } = res;
          this.tabArr = [...data];
          if (data.length > 0) {
            const { id } = data[0];
            if (this.helpTypeId) {
              this.tabArr.forEach((item, index) => {
                if (this.helpTypeId == item.id) {
                  this.active = index;
                }
              });
              this._getHelpView(this.aarItemId);
              return;
            }
            this.params.helpTypeId = id;
            this._getHelpList();
          }
        })
        .catch((res) => {})
        .finally(() => {});
    },
    //帮助列表
    _getHelpList() {
      getHelpList({ ...this.params, ...this.listQuery })
        .then((res) => {
          const {
            data: { totalCount, data },
          } = res;
          this.total = totalCount;
          this.listData = [...data];
        })
        .catch((res) => {})
        .finally(() => {});
    },
    //  查看
    _getHelpView(id) {
      getHelpView({ id })
        .then((res) => {
          const { data } = res;
          this.item = { ...data };
          const regex = new RegExp("<img", "gi");
          this.item.content = this.item.content.replace(
            regex,
            `<img class="rich-content"`
          );
        })
        .catch((res) => {})
        .finally(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  margin-top: -120px;
  background-color: #f6fafe;
  padding-bottom: 110px;
  .top-content {
    position: relative;
    height: 460px;
    .bg-content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      .image {
        width: 100%;
        height: 460px;
      }
    }
    .top-text {
      position: absolute;
      bottom: 70px;
      left: 0;
      right: 0;
      .title {
        color: #ffffff;
        font-size: 72px;
        font-weight: 700;
      }
      .search-box {
        width: 830px;
        height: 70px;
        margin: 15px auto 0;
        background-color: rgba(0, 0, 0, 0.3);
        border: 1px solid rgba(255, 255, 255, 0.6);
        display: flex;
        align-items: center;
        .input-box {
          flex: 1;
          /deep/ .el-input {
            .el-input__inner {
              background-color: transparent;
              border: none;
              font-size: 18px;
              color: #ffffff;
            }
          }
        }
        .line {
          height: 34px;
          width: 1px;
          margin-left: 10px;
          background-color: #ffffff;
        }
        .search-image {
          padding-left: 15px;
          padding-right: 19px;
          cursor: pointer;
          .image {
            width: 36px;
            height: 35px;
          }
        }
      }
    }
  }
  .main-content {
    margin: 0 auto;
    margin-top: 50px;
    width: 1320px;
    // height: 650px;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    .tab-box {
      width: 260px;
      // height: 650px;
      text-align: left;
      background: #ffffff;
      .title-tab {
        height: 60px;
        padding-left: 50px;
        background-color: #1082ff;
        line-height: 60px;
        font-size: 24px;
        font-weight: 700;
        color: #ffffff;
      }
      .list-box {
        height: 590px;
        overflow-x: hidden;
        overflow-y: hidden;
        .tab-list {
          .tab-item,
          .tab-item-select {
            padding-left: 46px;
            height: 60px;
            font-size: 18px;
            color: #333333;
            line-height: 60px;
            border-left: 4px solid #ffffff;
            cursor: pointer;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .tab-item-select {
            color: #1082ff;
            border-left: 4px solid #1082ff;
          }
        }
      }
      .list-box:hover {
        overflow-y: auto;
      }
    }

    .tab-content {
      flex: 1;
      padding-left: 40px;
      .content-title {
        height: 59px;
        font-size: 18px;
        padding-left: 10px;
        text-align: left;
        line-height: 59px;
        border-bottom: 1px solid #eeeeee;
        color: #333333;
      }
      .content-list-item {
        height: 60px;
        margin-top: 10px;
        line-height: 60px;
        display: flex;
        padding-left: 20px;
        padding-right: 20px;
        justify-content: space-between;
        border: 1px solid #eeeeee;
        cursor: pointer;
        .name {
          width: 800px;
          text-align: left;
          font-size: 18px;
          color: #333333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .time {
          margin-left: 20px;
          font-size: 14px;
          color: #666666;
        }
      }
      .content-list-item:hover {
        background-color: #1082ff;
        .name {
          color: #ffffff;
        }
        .time {
          color: #ffffff;
        }
      }
    }
    .item-detail {
      flex: 1;
      // height: 650px;
      border-left: 20px solid #f6fafe;
      overflow-x: hidden;
      overflow-y: hidden;
      .app-main {
        padding: 25px 20px 30px;
        text-align: left;
        .title {
          color: #666666;
          font-size: 24px;
        }
        .desc-box {
          font-size: 14px;
          color: #999999;
          margin-top: 10px;
          padding-bottom: 19px;
          border-bottom: 1px solid #cccccc;
          .time {
            padding-left: 20px;
          }
        }
        .html-box {
          margin-top: 30px;
        }
      }
    }
    .item-detail:hover {
      overflow-y: auto;
    }
  }
}
/deep/ .rich-text .rich-content {
  max-width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/help/index.vue